import React, { Suspense, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/en-gb";
import { Calendar, ConfigProvider } from "antd";
// eslint-disable-next-line camelcase
import En_GB from "antd/lib/locale-provider/en_GB";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import Spinner from "components/common/Spinner";
import Vacations from "components/menu/profile/vacations";
import CalendarHeader from "components/menu/profile/items/calendarHeader";
import SpecialAvailabilityDaysModal from "components/menu/profile/specialAvailabilityDaysModal";
import {
    profileGetSpecial,
} from "api/menu/profile/actions";

const colors = {
    special: {
        title: "Special Available Day (change of availabilty from general)",
        style: {
            color: "#fff",
            background: "#6fa8dc",
            boxShadow: "0 0 2px 2px #6fa8dc80",
        }
    },
    vacationFull: {
        title: "Vacation/Off Day (Full day)",
        style: {
            color: "#fff",
            background: "#cc0000",
            boxShadow: "0 0 2px 2px #cc000080",
        }
    },
    vacationPart: {
        title: "Vacation/Off Day (Partial day)",
        style: {
            color: "#fff",
            background: "#ff9900",
            boxShadow: "0 0 2px 2px #ff990080",
        }
    },
};

moment.locale("en_gb");

const TabSpecialAvailability = (props) => {
    const {
        loading,
        profileGetSpecial,
        specialAvailability,
        vacations
    } = props;

    const handleEdit = (date, id = false) => {
        const weekStart = moment(date).startOf("week").format("MMM DD"),
            weekEnd = moment(date).endOf("week").format("MMM DD");

        const modalObj = {
            id: `edit-special-availability-${id}`,
            header: `Special Availability (${weekStart} - ${weekEnd})`,
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SpecialAvailabilityDaysModal
                        id={id}
                        date={date}
                        onCancel={() => props.closeCustomModal(modalObj)}
                    />
                </Suspense>
            ),
            handleClose: () => props.closeCustomModal(modalObj)
        };
        props.openCustomModal(modalObj);
    };

    const [userSpecialAvailability, setUserSpecialAvailability] = useState(specialAvailability);

    useEffect(() => {
        profileGetSpecial();
    }, [profileGetSpecial]);

    useEffect(() => {
        setUserSpecialAvailability(specialAvailability);
    }, [specialAvailability]);

    return (
        <div className="position-relative py-4">
            {!loading || <Spinner />}

            <Vacations />

            <div className="mt-5">
                <div className="d-flex justify-content-between mb-3">
                    <h4 className="m-0">Special Availability</h4>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="special-availability-calendar-wrapper">
                            <ConfigProvider locale={En_GB}>
                                <Calendar
                                    fullscreen={false}
                                    defaultValue={moment()}
                                    headerRender={CalendarHeader}
                                    dateFullCellRender={date => {
                                        const currentSpecialAvailability =
                                            userSpecialAvailability.find(item => {
                                                const start = moment(item.startDate).valueOf(),
                                                    end = moment(item.endDate).valueOf(),
                                                    current = moment(date).valueOf();
                                            return current >= start && current <= end;
                                        });
                                        const style = {};
                                        if (currentSpecialAvailability) {
                                            style.background = colors.special.style.background;
                                            style.color = colors.special.style.color;
                                        }

                                        const currentVacation = vacations.find(item => {
                                            const start = moment(item.startDate).startOf("day").valueOf(),
                                                end = moment(item.endDate).endOf("day").valueOf(),
                                                current = moment(date).valueOf();
                                            return current >= start && current <= end;
                                        });

                                        if (currentVacation) {
                                            if (currentVacation.isPartial) {
                                                style.background =
                                                    colors.vacationPart.style.background;
                                                style.color = colors.vacationPart.style.color;
                                            } else {
                                                style.background =
                                                    colors.vacationFull.style.background;
                                                style.color = colors.vacationFull.style.color;
                                            }
                                        }
                                        return (
                                            <div
                                                className="g-pointer h-100 d-flex justify-content-center align-items-center"
                                                style={style}
                                                onClick={() => handleEdit(
                                                    date,
                                                    currentSpecialAvailability
                                                        ? currentSpecialAvailability.id
                                                        : false
                                                )}
                                            >
                                                {moment(date).format("DD")}
                                            </div>
                                        );
                                    }}
                                />
                            </ConfigProvider>
                        </div>
                    </div>
                    <div className="col-8">
                        {Object.keys(colors).map(colorKey => (
                            <div key={colorKey}>
                                <div className="special-availability-type">
                                    <div style={colors[colorKey].style} />
                                    {colors[colorKey].title}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    specialAvailability: state.profile.specialAvailability,
    vacations: state.profile.vacations,
});

const mapStateToDispatch = dispatch => ({
    profileGetSpecial: bindActionCreators(profileGetSpecial, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabSpecialAvailability);
